import axios from 'axios'
import { CADASTRAR_USUARIO_EMPRESA_AGENCIA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function cadastrarUsuariosEmpresaAgencia (idEmpresa, idUsuarioEmpresa, idAgencia) {

  const url = `${URL}/usuarios-empresa-agencia/usuario-empresa/${idUsuarioEmpresa}/empresa/${idEmpresa}/agencia/${idAgencia}/cadastrar`;
  return dispatch => axios.post(url, null, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CADASTRAR_USUARIO_EMPRESA_AGENCIA,
        payload: response
      })
  );
}
